/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:37:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:09:52                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * HoseDashCard - Display hose
*/

/* Imports */
import { Bars4Icon, HashtagIcon, QrCodeIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
/***/

/* Styles */
import "./HoseDashCard.scss";
/***/

/**
* HoseDashCard - Display hose
* @param hose - hose data
* @param onClick - on click event, trigger on component click
*/
export default function HoseDashCard({
  hose,
  onClick
}: {
  hose: EasyTech.Hose
  onClick?: () => void
}) {
  return (
  <div className="hose-card" onClick={() => onClick && onClick()}>
    <div className="flex justify-between ">
      <Typography className="text-blue-600 hover:underline">
        {hose.name}
      </Typography>
    </div>    
    <div className="icon-text-container">
      <div className="icon-text">
        <HashtagIcon className="w-5" />
        <Typography>
          {hose.ref}
        </Typography>
      </div>
      <div className="icon-text">
        {hose.qrCode ?
          <>
            <QrCodeIcon className="w-5" />
            <Typography>
              {hose.qrCode}
            </Typography>
          </>
          :
          hose.barCode &&
          <>
            <Bars4Icon className="w-5 rotate-90" />
            <Typography>
              {hose.barCode}
            </Typography>
          </>
        }
      </div>
    </div>
  </div>
  );
}
/***/
